import React from 'react';
import { motion } from 'framer-motion';
import { InteriorSlide, SlideHeader, SlideBanner } from './SlideShell';
import type { SlideProps } from './SlideShell';
export function Slide08Scale({
  index
}: SlideProps) {
  return <InteriorSlide surface banner={<SlideBanner eyebrow="Key Message" data-id="element-173">
          The master gives consistency and quality. Monthly adaptations give
          relevance and speed.
        </SlideBanner>} data-id="element-172">
      <SlideHeader eyebrow="Master-Based Production Logic" data-id="element-174">
        Build once, adapt monthly, optimize continuously
      </SlideHeader>

      <div className="flex-1 flex flex-col max-w-6xl mx-auto w-full" data-id="element-175">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3,
        duration: 0.5
      }} className="text-[clamp(1.1rem,1.4vw,1.3rem)] text-[var(--muted)] leading-relaxed mb-12 max-w-4xl" data-id="element-176">
          Because GSK Morocco plans approximately 12 Amoxil campaigns per year,
          the most efficient model is to create strong master assets and then
          adapt them into monthly campaigns.
        </motion.p>

        <div className="relative flex-1 bg-white rounded-2xl shadow-sm border border-black/5 p-8 overflow-hidden" data-id="element-177">
          {/* Timeline Track */}
          <div className="absolute top-1/2 left-8 right-8 h-1 bg-black/5 -translate-y-1/2" data-id="element-178" />

          <div className="relative h-full flex flex-col justify-between" data-id="element-179">
            {/* Top row: Masters */}
            <div className="flex justify-between items-end pb-8" data-id="element-180">
              <motion.div initial={{
              opacity: 0,
              y: -20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.5
            }} className="bg-[var(--brand)] text-white px-6 py-4 rounded-xl shadow-md w-64" data-id="element-181">
                <div className="text-xs font-bold uppercase tracking-wider text-white/70 mb-1" data-id="element-182">
                  Month 1
                </div>
                <div className="font-bold text-lg" data-id="element-183">
                  Initial Master Teaser & Trailer
                </div>
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              y: -20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.8
            }} className="bg-[var(--brand-light)] text-white px-6 py-4 rounded-xl shadow-md w-48 text-center" data-id="element-184">
                <div className="text-xs font-bold uppercase tracking-wider text-white/70 mb-1" data-id="element-185">
                  Month 6
                </div>
                <div className="font-bold" data-id="element-186">Teaser Master Update</div>
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              y: -20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 1.1
            }} className="bg-[var(--fg)] text-white px-6 py-4 rounded-xl shadow-md w-48 text-center" data-id="element-187">
                <div className="text-xs font-bold uppercase tracking-wider text-white/70 mb-1" data-id="element-188">
                  Month 12
                </div>
                <div className="font-bold" data-id="element-189">Trailer Master Update</div>
              </motion.div>
            </div>

            {/* Bottom row: 12-Month Calendar */}
            <div className="pt-8 w-full" data-id="element-190">
              <div className="grid grid-cols-12 gap-2 w-full" data-id="element-191">
                {['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].map((month, i) => <motion.div key={month} initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                delay: 0.6 + i * 0.05
              }} className="flex flex-col items-center gap-3" data-id="element-192">
                    <div className={`w-full h-12 rounded-lg flex items-center justify-center text-sm font-bold shadow-sm ${i < 6 ? 'bg-[var(--brand)] text-white' : 'bg-[var(--brand-light)] text-white'}`} data-id="element-193">
                      {i + 1}
                    </div>
                    <span className="text-xs font-bold text-[var(--muted)] uppercase tracking-wider" data-id="element-194">
                      {month}
                    </span>
                  </motion.div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </InteriorSlide>;
}